import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { FinanciamientoApiService } from "src/app/services/financiamiento-reusable.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { MatAccordion } from "@angular/material/expansion";
import { Globals } from "src/app/globals";
import { SupplyService } from "src/app/services/supply.service";
import { NavigationEnd, Router } from "@angular/router";
import { VisorDocumentosComponent } from "../visor-documentos/visor-documentos.component";
import { MatDialog } from "@angular/material";
import { DialogoConfirmacionComponent } from "../dialogo-confirmacion/dialogo-confirmacion.component";
import { Response } from "src/app/models/response";
import { ParametroApiService } from "src/app/services/parametro.service";

@Component({
  selector: "app-registrar-solicitante",
  templateUrl: "./registrar-solicitante.component.html",
  styleUrls: ["./registrar-solicitante.component.scss"],
})
export class RegistrarSolicitanteComponent implements OnInit, OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  panelOpenState = false;

  @BlockUI() blockUI: NgBlockUI;
  navigationSubscription;
  flagCodigovalidacion1: boolean = false;
  flagCodigovalidacion2: boolean;
  flagEnviar: boolean = true;
  toggle: boolean = true;
  mobileQuery: MediaQueryList;
  data: any;
  datos: FormGroup;
  limitFile: number;
  codigoValidacion: string;
  codigoValidacion2: string;
  codigoValidacionWeb: string;
  correoTemporal: string;
  correoTemporal2: string;
  showSuministro = true;
  celuValido: boolean;
  telefonoValido: boolean;
  validacionSMS: boolean;
  codigoValidacionTelefono: string;
  tiposDocumento = [
    {
      tipo: "",
      descripcion: "<<Seleccione>>",
    },
  ];
  parentescos = [
    {
      id_codigo: '',
      id_subcodigo: '',
      id_usua_crea: null,
      vl_val_parametro: '',
      tx_nom_parametro: '<<Seleccione>>',
    },
  ];

  dataSource: any[] = [];
  filesMap: Map<number, any> = new Map<number, any>();
  sizeFile: number = 0;
  juridica: boolean;
  labelname: string;
  labelapep: string;
  labelapem: string;
  labelmail: string;
  tipoPersona: string;
  listaParametro: any[];
  tipoValiCell: string;
  listaMsjes: any[];
  mailValidoPrincipal: boolean;
  mailValidoAlternativo: boolean;
  validarTelefonoSIMPLE: boolean;
  validarCelularSIMPLE: boolean;
  showCheckCelular: boolean;
  tamanoMaxFile: any;
  checkUno: boolean;
  checkDos: boolean;
  parametrosCorreo: any;
  maxLength: string;
  validaDoc: number = 0;
  showButton: boolean = true;
  verDocumentos: boolean = true;
  validNumDni: boolean;
  validNumRuc: boolean;

  private _mobileQueryListener: () => void;

  docAdjuntos: any = [];

  constructor(
    private supplyService: SupplyService,
    private toastr: ToastrService,
    private financiamientoApiService: FinanciamientoApiService,
    private parametrosApiService: ParametroApiService,
    private router: Router,
    private globals: Globals,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public dialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd && this.showSuministro === false) {
        this.showSuministro = true;
        this.ngOnInit();
      }
    });
    // Inicialización label defecto
    this.labelDefecto();
    this.datos = new FormGroup({
      suministro: new FormControl("", Validators.required),
      parentesco: new FormControl("", Validators.required),
      razonsocialRRLL: this.juridica ? new FormControl("", Validators.required) : new FormControl(""),
      nombres: new FormControl("", Validators.required),
      paterno: new FormControl("", Validators.required),
      materno: new FormControl("", Validators.required),
      tipDocumento: new FormControl("", Validators.required),
      numDocumento: new FormControl("", Validators.required),
      telefono: new FormControl(""),
      celular: new FormControl("", Validators.required),
      codigoC1: new FormControl(""),
      codigoC2: new FormControl(""),
      codigoC3: new FormControl(""),
      codigoC4: new FormControl(""),
      correo: new FormControl("", [Validators.required, Validators.email]),
      codigo1: new FormControl("", Validators.required),
      codigo2: new FormControl("", Validators.required),
      codigo3: new FormControl("", Validators.required),
      codigo4: new FormControl("", Validators.required),
      correoSecundario: new FormControl("", [Validators.email]),
      codigoS1: new FormControl(""),
      codigoS2: new FormControl(""),
      codigoS3: new FormControl(""),
      codigoS4: new FormControl("")
    });

  }

  get f() {
    return this.datos.controls;
  }

  ngOnInit() {

    // Validación de variables globales
    if (this.globals.tip_docum === '' || this.globals.suministro === '' || this.globals.num_docum === '') {
      this.toastr.warning("Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados", "Atención", {
        timeOut: 5000,
      });
      this.router.navigate(['/iniciar-sesion']);
      return;
    }
    this.mailValidoPrincipal = false;
    this.mailValidoAlternativo = false;
    this.validarTelefonoSIMPLE = false;
    this.validarCelularSIMPLE = false;
    this.celuValido = false;
    this.telefonoValido = false;
    this.validacionSMS = false;
    this.checkUno = true;
    this.checkDos = true;
    this.disableCamposDefault();

    // Obtener Tipo Documentos
    this.financiamientoApiService.getTipoDocumentos().subscribe((response) => {
      this.tiposDocumento = this.tiposDocumento.concat(response.resultado);
    });

    // Obtener Tipos de Parentesco
    this.cargarParentesco();
    // Verificar validacion telefono x sms
    this.cargarValidacionCelular();
    // Lista de mensajes en pantalla
    this.cargarMsjPantalla();
    // Obtener limite capacidad de archivos
    this.cargarParametrosFile();

    this.initSolicitante();
    const body = {
      clase: "VALIDACION CORREOS ARD",
      modulo: "ARD_WEB",
      categoria: ""
    };

    this.parametros(body);

    let tipDoc = this.datos.value.tipDocumento;
    if (tipDoc == "TD001") {
      //DNI
      this.validaDoc = 1; //numerico
      this.maxLength = '8';
    } else {
      if (tipDoc == "TD002") {
        //RUC
        this.validaDoc = 1; //numerico
        this.maxLength = '11';
      } else {
        if (tipDoc == "TD003") {
          //CARNET DE EXTRANJERIA
          this.validaDoc = 2; //alfa-numerico
          this.maxLength = '12';
        } else {
          if (tipDoc == "TD005") {
            //PASAPORTE
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '12';
          } else {
            //LOS DEMAS TIPOS
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '15';
          }
        }
      }
    }


  }

  /*Valida el ingreso de texto a-z, A-Z, ñ, vovales con tilde y espacio */
  public validarCaracter(event : KeyboardEvent){
    const patternAlfaNumeric = /[a-zA-ZñÑá-úÁ-Ú ]/;
    const inputChar = String.fromCharCode((event).charCode);
    if (!patternAlfaNumeric.test(inputChar)) {
      event.preventDefault();
    }
  }

  labelDefecto() {
    //this.juridica = false;
    this.labelname = 'Nombre(s)';
    this.labelapep = 'Apellido Paterno';
    this.labelapem = 'Apellido Materno';
    this.labelmail = 'Correo';
    this.tipoPersona = 'PS001'; // Natutal
  }

  disableCamposDefault() {
    this.datos.controls['codigo1'].disable();
    this.datos.controls['codigo2'].disable();
    this.datos.controls['codigo3'].disable();
    this.datos.controls['codigo4'].disable();
    this.datos.controls['codigoS1'].disable();
    this.datos.controls['codigoS2'].disable();
    this.datos.controls['codigoS3'].disable();
    this.datos.controls['codigoS4'].disable();
    this.datos.controls['codigoC1'].disable();
    this.datos.controls['codigoC2'].disable();
    this.datos.controls['codigoC3'].disable();
    this.datos.controls['codigoC4'].disable();
  }

  async cargarParentesco() {
    this.listaParametro = [];
    await this.consultaParametros('5', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    this.parentescos = this.parentescos.concat(this.listaParametro);
  }

  async cargarValidacionCelular() {
    
    this.listaParametro = [];
    await this.consultaParametros('8', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    const validarSMS = this.listaParametro.find(x => x.vl_val_parametro === '1');
    if (validarSMS.tx_nom_parametro === 'SIMPLE') {
      this.tipoValiCell = 'VT001'; // Simple
    } else {
      this.tipoValiCell = 'VT002'; // SMS
    }
  }

  async cargarMsjPantalla() {
    this.listaParametro = [];
    this.listaMsjes = [];
    await this.consultaParametros('7', '');

    this.listaMsjes = this.listaParametro.filter(x => x.id_subcodigo !== 0);

  }

  async consultaParametros(codigo: string, subcodigo: string) {
    await this.parametrosApiService.consultarParametro(codigo, subcodigo).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            this.listaParametro = response.resultado;
          }
        }
      },
      (error) => {

      }
    );
  }

  async cargarParametrosFile() {
    this.listaParametro = [];
    await this.consultaParametros('4', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    this.tamanoMaxFile = this.listaParametro.find(x => x.id_subcodigo === 1);
    this.limitFile = (Number(this.tamanoMaxFile.vl_val_parametro) / (1024 * 1024));
  }

  async parametros(body: any) {
    await this.financiamientoApiService.getParametrosGc(body).toPromise()
      .then((response) => {

        this.parametrosCorreo = response.resultado;
      });
  }

  initSolicitante() {
    this.datos["controls"]["suministro"].setValue(
      this.globals.suministro.toString()
    );
    this.datos["controls"]["tipDocumento"].setValue(
      this.globals.tip_docum.toString()
    );
    this.datos["controls"]["numDocumento"].setValue(
      this.globals.num_docum.toString()
    );
  }

  irInicioSesion() {
    this.router.navigate(['']);
  }

  buscarDocs2() {
    //this.dataSource = [];
    this.labelDefecto();
    this.datos.controls['razonsocialRRLL'].clearValidators(); // eliminar validacion
    this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion

    const body = {
      parentescoCod: this.datos.value.parentesco.toString(),
    };
    if (this.datos.value.parentesco.toString() === 'RW001' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW002' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW004' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW003' && this.globals.tip_docum.toString() == 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW001' && this.globals.tip_docum.toString() == 'TD002') {
      this.labelJuridico(); // Persona Juridica
      this.datos.get('razonsocialRRLL').setValidators(Validators.required); // agregar validacion
      this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion
    }else if (this.datos.value.parentesco.toString() === 'RW002' && this.globals.tip_docum.toString() == 'TD002'){
      if(!this.juridica){
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 28);
        this.mensajeWarning(mensaje.vl_val_parametro);
        if(this.datos.value.parentesco.toString() === 'RW002' || this.datos.value.parentesco.toString() === 'RW004'){
          this.datos["controls"]["parentesco"].setValue("");
        }
      }else{
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 30);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }

    }else if (this.datos.value.parentesco.toString() === 'RW004' && this.globals.tip_docum.toString() == 'TD002') {
      if(!this.juridica){
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 29);
        this.mensajeWarning(mensaje.vl_val_parametro);
        if(this.datos.value.parentesco.toString() === 'RW002' || this.datos.value.parentesco.toString() === 'RW004'){
          this.datos["controls"]["parentesco"].setValue("");
        }
      }else{
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 30);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
    }

    //this.cargarDocsParentesco(body.parentescoCod);
  }

  buscarDocs() {
    
    this.dataSource = [];
    this.labelDefecto();
    this.datos.controls['razonsocialRRLL'].clearValidators(); // eliminar validacion
    this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion

    const body = {
      parentescoCod: this.datos.value.parentesco.toString(),
    };
    if (this.datos.value.parentesco.toString() === 'RW001' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW002' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW004' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW003' && this.globals.tip_docum.toString() == 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
      this.juridica = false;
    } else if (this.datos.value.parentesco.toString() === 'RW001' && this.globals.tip_docum.toString() == 'TD002') {
      this.labelJuridico(); // Persona Juridica
      this.datos.get('razonsocialRRLL').setValidators(Validators.required); // agregar validacion
      this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion
    }else if (this.datos.value.parentesco.toString() === 'RW002' && this.globals.tip_docum.toString() == 'TD002'){
      if(!this.juridica){
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 28);
        this.mensajeWarning(mensaje.vl_val_parametro);
        if(this.datos.value.parentesco.toString() === 'RW002' || this.datos.value.parentesco.toString() === 'RW004'){
          this.datos["controls"]["parentesco"].setValue("");
        }
      }else{
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 30);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }

    }else if (this.datos.value.parentesco.toString() === 'RW004' && this.globals.tip_docum.toString() == 'TD002') {
      if(!this.juridica){
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 29);
        this.mensajeWarning(mensaje.vl_val_parametro);
        if(this.datos.value.parentesco.toString() === 'RW002' || this.datos.value.parentesco.toString() === 'RW004'){
          this.datos["controls"]["parentesco"].setValue("");
        }
      }else{
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 30);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
    }

    this.cargarDocsParentesco(body.parentescoCod);
  }

  labelJuridico() {
    this.juridica = true;
    this.labelname = this.labelname + ' RRLL';
    this.labelapep = this.labelapep + ' RRLL';
    this.labelapem = this.labelapem + ' RRLL';
    this.labelmail = this.labelmail + ' Principal';
    this.tipoPersona = 'PS002'; // Juridica
  }

  async cargarDocsParentesco(body: string) {
    const listaParentesco = this.parentescos;
    this.listaParametro = [];
    await this.consultaParametros('6', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    const parentesco = listaParentesco.find(x => x.vl_val_parametro === body);
    const documentos = this.listaParametro.filter(x => x.tx_nom_parametro.toString() === parentesco.id_subcodigo.toString());

    let datasource: {
      descTipo: string,
      disabledAdjuntar: boolean,
      disabledEliminar: boolean,
      docAdjunto: string,
      estadoDocumento: string,
      flagDocumentHabilitado: boolean,
      id: number,
      idBandeja: number,
      idBandejaDoc: number,
      motivoRechazo: string,
      tieneDocumento: boolean,
      tipo: string,
      size: string
    }[] = [];
    for (let i = 0; i < documentos.length; i++) {

     /* let tipoDoc = '';
      if(documentos[i].vl_val_parametro == 'Documento que acredite propiedad'){
        tipoDoc = 'AW001';
      }else if(documentos[i].vl_val_parametro == 'Documento de Identidad Persona Natural y Ficha RUC para Persona Juridica (para verificar datos)'){
        tipoDoc = 'AW002';
      }else if(documentos[i].vl_val_parametro == 'Carta poder simple, adjuntando los documentos asignados al poderdante. En caso de personeria juridica, copia de la vigencia de poderes emitida por los Registros Publicos con una antiguedad no mayor de seis (06) meses'){
        tipoDoc = 'AW003';
      }else if(documentos[i].vl_val_parametro == 'Copia del Contrato de Arrendamiento vigente. De no contar con contrato de arrendamiento, o se encuentre vencido y tenga imposibilidad para presentar carta poder suscrita por el propietario, deberá suscribir la declaración jurada'){
        tipoDoc = 'AW004';
      }else if(documentos[i].vl_val_parametro == 'Documento que acredite que se encuentre habilitado para realizar el trámite'){
        tipoDoc = 'AW005';
      }else{
        tipoDoc = 'AW999';
      }*/

      datasource.push({
        descTipo: documentos[i].vl_val_parametro,
        disabledAdjuntar: false,
        disabledEliminar: false,
        docAdjunto: ' ',
        estadoDocumento: 'DW001',
        flagDocumentHabilitado: true,
        id: i + 1,
        idBandeja: 0,
        idBandejaDoc: 0,
        motivoRechazo: ' ',
        tieneDocumento: false,
        tipo: documentos[i].tipo,
        size: ''
      })
    }
    this.dataSource = datasource;
  }

  async verEvent(event: any) {
    let file = this.filesMap.get(event.id).file;
    const dialogRef = this.dialog.open(VisorDocumentosComponent, {
      data: {
        src: await this.getBase64(file),
        nombre: file.name,
        tipo: file.type,
      },
    });
  }

  async getBase64(file: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  getFileChanged(j: number, filename: string) {
    let returned: string = "";
    let tipoExtension: string;
    let nroSuministro: string = "0";
    let nroDocumento: string;

    tipoExtension = filename.split(".").pop();
    nroSuministro = this.globals.suministro.toString();
    nroDocumento = this.globals.num_docum.toString();

    returned = nroSuministro + "_" + nroDocumento + "_" + (j) + "." + tipoExtension;
    return returned;
  }

  adjuntarEvent(event: any) {
    let totalSize = 0;
    this.filesMap.forEach((value: any, key: any) => {
      totalSize += value.file.size;
    });
    totalSize += event.file.size;
    if (totalSize > this.tamanoMaxFile.vl_val_parametro) {
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 23);
      this.mensajeWarning(mensaje.vl_val_parametro+" ("+this.limitFile+ " MB)");
      return;
    }
    this.filesMap.set(event.item.id, { file: event.file, item: event.item });
    let item = this.dataSource.find((x) => x.id === event.item.id);
    let factor: number = 1048576;
    if (item) {
      item.docAdjunto = this.getFileChanged(item.id, event.file.name);
      item.tieneDocumento = true;

      let capacidad:number = parseInt(event.file.size) / factor;

      item.size = capacidad.toFixed(2);
      item.tipoExt = event.file.type === 'image/jpeg' ? 'jpg' : 'pdf';
    }
  }

  mensajeWarning(mensaje: string) {
    this.toastr.warning(mensaje, "Advertencia", { closeButton: true, });
  }
  mensajeInfo(mensaje: string) {
    this.toastr.info(mensaje, "Información", { closeButton: true, });
  }

  eliminarEvent(event: any) {
    this.mostrarDialogo(event);
  }

  verCheckUno(event: any) {
    this.checkUno = event;
  }

  verCheckDos(event: any) {
    this.checkDos = event;
  }

  mostrarDialogo(event: any): void {
    this.dialog
      .open(DialogoConfirmacionComponent, {
        data: `¿Desea eliminar el documento seleccionado?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.filesMap.delete(event.id);
          event.docAdjunto = "";
          event.tieneDocumento = false;
        }
      });
  }

  validacionCorreoFinal() {
    this.codigoValidacionWeb =
      this.datos.value.codigo1.toString() +
      this.datos.value.codigo2.toString() +
      this.datos.value.codigo3.toString() +
      this.datos.value.codigo4.toString();

    this.flagCodigovalidacion1 = false;
    if (this.datos.value.correo.toString() == this.correoTemporal) {
      if (this.codigoValidacionWeb == this.codigoValidacion) {
        this.flagCodigovalidacion1 = true;
        this.flagEnviar = false;
        this.toggle = false;
        this.deshabilitarInputsCorreo();
        // this.toastr.success("Validación de correo satisfactoria.", "Atención", {closeButton: true,});
      } else {
        this.flagEnviar = true;
        this.toggle = true;
        this.datos["controls"]["codigo1"].setValue("");
        this.datos["controls"]["codigo2"].setValue("");
        this.datos["controls"]["codigo3"].setValue("");
        this.datos["controls"]["codigo4"].setValue("");
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 16);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
    } else {
      this.flagCodigovalidacion1 = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigo1"].setValue("");
      this.datos["controls"]["codigo2"].setValue("");
      this.datos["controls"]["codigo3"].setValue("");
      this.datos["controls"]["codigo4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }
  }

  validacionCorreoSecundarioFinal() {
    this.codigoValidacionWeb =
      this.datos.value.codigoS1.toString() +
      this.datos.value.codigoS2.toString() +
      this.datos.value.codigoS3.toString() +
      this.datos.value.codigoS4.toString();

    this.flagCodigovalidacion2 = false;
    if (this.datos.value.correoSecundario.toString() == this.correoTemporal2) {
      if (this.codigoValidacionWeb == this.codigoValidacion2) {
        this.flagCodigovalidacion2 = true;
        this.flagEnviar = false;
        this.toggle = false;
        this.deshabilitarInputsCorreoSecundario();
        // this.toastr.success("Validación de correo satisfactoria.", "Atención", {closeButton: true,});
      } else {
        this.flagEnviar = true;
        this.toggle = true;
        this.datos["controls"]["codigoS1"].setValue("");
        this.datos["controls"]["codigoS2"].setValue("");
        this.datos["controls"]["codigoS3"].setValue("");
        this.datos["controls"]["codigoS4"].setValue("");
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 16);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }
    } else {
      this.flagCodigovalidacion2 = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigoS1"].setValue("");
      this.datos["controls"]["codigoS2"].setValue("");
      this.datos["controls"]["codigoS3"].setValue("");
      this.datos["controls"]["codigoS4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }
  }

  stripSuministro() {
    let suministroValido = false;
    let suministro = this.datos.value.suministro;
    let CELULAR_REGEX = /^[0-9]{7}$/;
    suministro = String(suministro);

    if (suministro.match(CELULAR_REGEX)) {
      suministroValido = true;
    }
    if (!suministroValido) {
      this.blockUI.stop();
      this.toastr.warning('Suministro debe tener 7 digitos', 'Atención', {closeButton: true});
      return;
    }
  }

  validaCorreo() {
    if (this.mailValidoPrincipal) {
     /* (<any>Object).values(this.datos.controls).forEach((control) => {
        control.markAsTouched();
      });*/
      //JPUYEN (se marca como tocados solo a nombes y apellidos y muestre requeridos en pantalla)
      this.datos.controls.nombres.markAsTouched();
      this.datos.controls.paterno.markAsTouched();
      this.datos.controls.materno.markAsTouched();
      //END
      this.correoTemporal = this.datos.value.correo.toString();
      let camposValidados: boolean = true;

      if (this.datos.value.parentesco.toString() === 'RW001' && this.globals.tip_docum.toString() == 'TD002') {

        if (this.datos.value.nombres != "" &&
          this.datos.value.nombres != undefined &&
          this.datos.value.materno != "" &&
          this.datos.value.materno != undefined && this.datos.value.paterno != "" &&
          this.datos.value.paterno != undefined &&
          this.datos.value.correo != "" &&
          this.datos.value.correo != undefined
          /*this.datos.value.razonsocialRRLL != "" &&
          this.datos.value.razonsocialRRLL != undefined*/
          ) {
          camposValidados = true;
        } else {
          camposValidados = false;
        }

      } else {
        if (this.datos.value.nombres != "" &&
          this.datos.value.nombres != undefined &&
          this.datos.value.paterno != "" &&
          this.datos.value.paterno != undefined &&
          this.datos.value.materno != "" &&
          this.datos.value.materno != undefined &&
          this.datos.value.correo != "" &&
          this.datos.value.correo != undefined) {
          camposValidados = true;
        } else {
          camposValidados = false;
        }

      }
      if (camposValidados) {
        let remitente = this.datos.value.nombres + " " + this.datos.value.paterno + " " + this.datos.value.materno;

        const body = {
          usuario: remitente.toUpperCase(),
          //usuario: "",
          email: this.datos.value.correo.toString(),
          asunto: this.parametrosCorreo[0].valor,
          rutaLogo: this.parametrosCorreo[1].valor,
          parrafo_01: this.parametrosCorreo[2].valor,
          parrafo_02: this.parametrosCorreo[3].valor,
          remitente: this.parametrosCorreo[4].valor,
          sistema: this.parametrosCorreo[5].valor.toUpperCase()
        };
        //Obtener Codigo de verificacion
        this.codigoValidacion = "";
        this.supplyService.validarCorreo(body).subscribe((response) => {
          this.codigoValidacion = response.bRESP.data.codigoVerificacion;

          if (this.codigoValidacion.length) {
            this.habilitarInputsMailPrincipal();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 15);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de correo no esta disponible, Verifique con su administrador!');
          }
        });
      } else {
        this.toastr.warning("Los campos Nombres, Apellidos y Correo Electrónico son necesarios para la notificación de correo", "Atención", { closeButton: true });
        return;
      }
    }
  }

  habilitarInputsMailPrincipal() {
    this.datos.controls['codigo1'].enable();
    this.datos.controls['codigo2'].enable();
    this.datos.controls['codigo3'].enable();
    this.datos.controls['codigo4'].enable();
  }

  habilitarInputsCelular() {
    this.datos.controls['codigoC1'].enable();
    this.datos.controls['codigoC2'].enable();
    this.datos.controls['codigoC3'].enable();
    this.datos.controls['codigoC4'].enable();
  }

  validaCorreoSecundario() {
    debugger
    if (this.mailValidoAlternativo) {
     /* (<any>Object).values(this.datos.controls).forEach((control) => {
        control.markAsTouched();
      });*/
      this.correoTemporal2 = this.datos.value.correoSecundario.toString();
      let camposValidados: boolean = true;

      if (this.datos.value.nombres != "" &&
        this.datos.value.nombres != undefined &&
        this.datos.value.paterno != "" &&
        this.datos.value.paterno != undefined &&
        this.datos.value.materno != "" &&
        this.datos.value.materno != undefined &&
        this.datos.value.correoSecundario != "" &&
        this.datos.value.correoSecundario != undefined
       /* this.datos.value.razonsocialRRLL != "" &&
        this.datos.value.razonsocialRRLL != undefined*/) {
        if (this.datos.controls.correo.value === this.datos.value.correoSecundario.trim()) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 25);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        } else {
          camposValidados = true;
        }
      } else {
        camposValidados = false;
      }

      if (camposValidados) {
        let remitente = this.datos.value.nombres + ", " + this.datos.value.paterno + " " + this.datos.value.materno;

        const body = {
          usuario: remitente,
          //usuario: "",
          email: this.datos.value.correoSecundario.toString(),
          asunto: this.parametrosCorreo[0].valor,
          rutaLogo: this.parametrosCorreo[1].valor,
          parrafo_01: this.parametrosCorreo[2].valor,
          parrafo_02: this.parametrosCorreo[3].valor,
          remitente: this.parametrosCorreo[4].valor,
          sistema: this.parametrosCorreo[5].valor.toUpperCase()
        };

        //Obtener Codigo de verificacion
        this.codigoValidacion2 = "";
        this.supplyService.validarCorreo(body).subscribe((response) => {
          this.codigoValidacion2 = response.bRESP.data.codigoVerificacion;
          if (this.codigoValidacion2.length) {
            this.habilitarInputsMailAlternativo();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 15);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de correo no esta disponible, Verifique con su administrador!');
          }
        });

      } else {
        this.toastr.warning("Los campos Nombres, Apellidos y Correo Electrónico son necesarios para la notificación de correo", "Atención", { closeButton: true });
        return;
      }
    }
  }

  habilitarInputsMailAlternativo() {
    this.datos.controls['codigoS1'].enable();
    this.datos.controls['codigoS2'].enable();
    this.datos.controls['codigoS3'].enable();
    this.datos.controls['codigoS4'].enable();
  }

  stripCorreo(tipoMail: number) {
    let email = '';
    if (tipoMail === 1) {
      this.mailValidoPrincipal = false;
      email = this.datos.controls.correo.value;
    } else if (tipoMail === 2) {
      this.mailValidoAlternativo = false;
      email = this.datos.value.correoSecundario;
    }

    const EMAIL_REGEX = /^[a-zA-Z]+[a-zA-Z0-9._-]+@[a-zA-Z]+\.[a-zA-Z.]{2,5}$/;     //   /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/; // /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
                       
    if (EMAIL_REGEX.test(email.trim())) {
      if (tipoMail === 1) {
        this.mailValidoPrincipal = true;
        this.flagCodigovalidacion1 = false;
        this.datos["controls"]["codigo1"].setValue("");
        this.datos["controls"]["codigo2"].setValue("");
        this.datos["controls"]["codigo3"].setValue("");
        this.datos["controls"]["codigo4"].setValue("");
      } else if (tipoMail === 2) {
        this.mailValidoAlternativo = true;
        this.flagCodigovalidacion2 = false;
        this.datos["controls"]["codigoS1"].setValue("");
        this.datos["controls"]["codigoS2"].setValue("");
        this.datos["controls"]["codigoS3"].setValue("");
        this.datos["controls"]["codigoS4"].setValue("");
      }
    }
    if (tipoMail === 1) {
      if (!this.mailValidoPrincipal) {

        if(email != "" && email != undefined){
          this.blockUI.stop();
          this.mailValidoPrincipal = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 14);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        }else{
          this.blockUI.stop();
          this.mailValidoPrincipal = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 13);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        }

      }
    } else if (tipoMail === 2) {
      if (!this.mailValidoAlternativo && email.trim() != "") {
        this.blockUI.stop();
        this.mailValidoAlternativo = false;
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 24);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }else{
        if(this.datos.controls.correo.value.trim()==this.datos.value.correoSecundario.trim()){
          this.blockUI.stop();
          this.mailValidoAlternativo = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 25);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;

        }
      }
    }
  }

  stripCelular() {
    
    this.celuValido = false;
    let celularValido = false;
    this.validarCelularSIMPLE = false;
    let celular = this.datos.value.celular;
    let CELULAR_REGEX = /^[0-9]{9}$/;
    celular = String(celular);
    if (celular.match(CELULAR_REGEX)) {
      celularValido = true;
      this.celuValido = true;
      this.validarCelularSIMPLE = true;
    }
    if (!celularValido && celular.toString()!="") {
      this.blockUI.stop();
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 18);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return;
    } else {
      let strCelular = celular.toString();
      if(strCelular=="" || strCelular==undefined){

        this.blockUI.stop();
        this.celuValido = false;
        this.validarCelularSIMPLE = false;
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 17);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;

      }else{

        let primerNumero = strCelular.substring(0, 1);

        if (primerNumero != '9') {
          this.blockUI.stop();
          this.celuValido = false;
          this.validarCelularSIMPLE = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 19);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        }

        this.stripTelefono();

      }

    }
  }

  stripTelefono() {
    
    let telefono = this.datos.value.telefono;
    this.validarTelefonoSIMPLE = true;
    if (telefono!="" && telefono.length < 7) {
      this.validarTelefonoSIMPLE = false;
      this.blockUI.stop();
      this.telefonoValido = false;
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 20);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return;
    }else{
      if(this.validarCelularSIMPLE){
        this.telefonoValido = true;
      }else{
        this.telefonoValido = false;
      }
    }
  }

  validaCelular() {
    //debugger
    this.showCheckCelular = false;
    this.stripCelular();
    if (this.tipoValiCell === 'VT001') {
      //validacion simple
      if (this.validarCelularSIMPLE || this.validarTelefonoSIMPLE) {
        if(this.telefonoValido && this.celuValido){
          this.showCheckCelular = true;
          this.deshabilitarInputsTelefonos();
        }

      }

    }else{
      //Validacion por msje de texto
      if(this.datos.value.celular != "" && this.datos.value.celular != undefined){
        const body = {
          celular: this.datos.value.celular.toString()
        };

        //Obtener Codigo de verificacion
        this.codigoValidacionTelefono = "";
        this.supplyService.validarCelular(body).subscribe((response) => {
          this.codigoValidacionTelefono = response;
          if (this.codigoValidacionTelefono!="" && this.codigoValidacionTelefono!=undefined) {
            this.habilitarInputsCelular();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 21);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de celular no esta disponible, Verifique con su administrador!');
          }
        });

      }

    }

  }

  validacionCelular() {
    let codigoValidacionCelular =
      this.datos.value.codigoC1.toString() +
      this.datos.value.codigoC2.toString() +
      this.datos.value.codigoC3.toString() +
      this.datos.value.codigoC4.toString();

   // this.flagCodigovalidacion1 = false;
  //  if (this.datos.value.correo.toString() == this.correoTemporal) {
      if (codigoValidacionCelular == this.codigoValidacionTelefono) {
     /*   this.flagCodigovalidacion1 = true;
        this.flagEnviar = false;
        this.toggle = false;*/
        // this.toastr.success("Validación de correo satisfactoria.", "Atención", {closeButton: true,});
        this.showCheckCelular = true;
        this.deshabilitarInputsTelefonos();


      } else {
        this.flagEnviar = true;
        this.toggle = true;
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 22);
        this.mensajeWarning(mensaje.vl_val_parametro);
        this.datos["controls"]["codigoC1"].setValue("");
        this.datos["controls"]["codigoC2"].setValue("");
        this.datos["controls"]["codigoC3"].setValue("");
        this.datos["controls"]["codigoC4"].setValue("");
      }
    /*} else {
      this.flagCodigovalidacion1 = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigo1"].setValue("");
      this.datos["controls"]["codigo2"].setValue("");
      this.datos["controls"]["codigo3"].setValue("");
      this.datos["controls"]["codigo4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }*/
  }

  deshabilitarInputsTelefonos() {
    this.datos.controls['celular'].disable();
    this.datos.controls['telefono'].disable();
    this.datos.controls["codigoC1"].disable();
    this.datos.controls["codigoC2"].disable();
    this.datos.controls["codigoC3"].disable();
    this.datos.controls["codigoC4"].disable();
  }

  deshabilitarInputsCorreo() {
    this.datos.controls['correo'].disable();
    this.datos.controls["codigo1"].disable();
    this.datos.controls["codigo2"].disable();
    this.datos.controls["codigo3"].disable();
    this.datos.controls["codigo4"].disable();
  }

  deshabilitarInputsCorreoSecundario() {
    this.datos.controls['correoSecundario'].disable();
    this.datos.controls["codigoS1"].disable();
    this.datos.controls["codigoS2"].disable();
    this.datos.controls["codigoS3"].disable();
    this.datos.controls["codigoS4"].disable();
  }

  stripText(control: FormControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ""));
  }

  validarTelefonoTexto(event: any) {
    let telefono = event.target.value;
    let i: any
    for (i = 0; i < telefono.length; i++) {
      var code = telefono.charCodeAt(i);
      if (code < 48 || code > 57) {
        event.target.value = "";
        this.toastr.warning('El telefono debe ser sólo numeros', 'Atención', { closeButton: true });
        return;
      }
    }

  }

  validarCelularTexto(event: any) {
    let telefono = event.target.value;
    let i: any
    for (i = 0; i < telefono.length; i++) {
      var code = telefono.charCodeAt(i);
      if (code < 48 || code > 57) {
        event.target.value = "";
        this.toastr.warning('El celular debe ser sólo numeros', 'Atención', { closeButton: true });
        return;
      }
    }

  }

  validData() {
    let isValiddata = false;
    if(!this.showCheckCelular){
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 41);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return false;
    }
      if(!this.flagCodigovalidacion1){

        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 63);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }

      if(this.datos.value.correoSecundario && this.mailValidoAlternativo){
        if(!this.flagCodigovalidacion2 && this.juridica){
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 42);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return false;
        }
      }


    this.validNumDni = false;
    this.validNumRuc = false;

    if (this.datos.value.tipDocumento == "TD001") {
      //DNI
      this.validNumDni=true;
    } else if (this.datos.value.tipDocumento == "TD002") {
      //RUC
      this.validNumRuc = true;
    }

    if(this.validNumDni){
      if(this.datos.value.numDocumento.length!==8){
        this.toastr.warning('El numero de documento DNI debe tener 8 digitos', 'Atención', {closeButton: true});
        return false;
      }

    }
    if(this.validNumRuc){
      if(this.datos.value.numDocumento.length!==11){
        this.toastr.warning('El numero de documento RUC debe tener 11 digitos', 'Atención', {closeButton: true});
        return false;
      }

    }
    this.stripSuministro();
    // Validar documentos
    const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 43);
    if(this.dataSource.length > 0){
      for (let index = 0; index < this.dataSource.length; index++) {
        if (this.dataSource[index].docAdjunto === null || this.dataSource[index].docAdjunto === undefined) {
          this.mensajeWarning(mensaje.vl_val_parametro);
          return false;
          /*
          this.toastr.warning(
            mensaje.vl_val_parametro,
            //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
            "Atención",
            { closeButton: true }
          );
          */
          //return false;
        } else {
          let strDocAdjunto = this.dataSource[index].docAdjunto;
          //console.log('doc adjunto ... '+strDocAdjunto)
          strDocAdjunto = strDocAdjunto.replace(/\s/g, "");
          if (strDocAdjunto.length == 0) {
            this.mensajeWarning(mensaje.vl_val_parametro);
            return false;
            /*
            this.toastr.warning(
              mensaje.vl_val_parametro,
              //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
              "Atención",
              { closeButton: true }
            );*/
            //return false;
          }
        }
    }
    }else{
      this.mensajeWarning(mensaje.vl_val_parametro);
      return false;
    }



    return true;
  }

  validForm() {
    
    (<any>Object).values(this.datos.controls).forEach((control) => {
      control.markAsTouched();
    });
    this.buscarDocs2();
    if (this.datos.invalid) {
      
      let vSuministro=this.datos.controls.suministro.value;
        if (vSuministro === '' || vSuministro === null || vSuministro === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 31);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        let vparentesco=this.datos.controls.parentesco.value;
        if (vparentesco === '' || vparentesco === null || vparentesco === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 32);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        let vnombres=this.datos.controls.nombres.value;
        if (vnombres === '' || vnombres === null || vnombres === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 33);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        let vpaterno=this.datos.controls.paterno.value;
        if (vpaterno === '' || vpaterno === null || vpaterno === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 34);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        let vmaterno=this.datos.controls.materno.value;
        if (vmaterno === '' || vmaterno === null || vmaterno === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 35);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        let tipoDoc=this.datos.controls.tipDocumento.value;
        if (tipoDoc === '' || tipoDoc === null || tipoDoc === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 64);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

        if(this.juridica){
          let vrazonsocialRRLL=this.datos.controls.razonsocialRRLL.value;
          if (vrazonsocialRRLL === '' || vrazonsocialRRLL === null || vrazonsocialRRLL === undefined) {
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 36);
            this.mensajeWarning(mensaje.vl_val_parametro);
          }
        }

        let vnumDocumento=this.datos.controls.numDocumento.value;
        if (vnumDocumento === '' || vnumDocumento === null || vnumDocumento === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 40);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }

      if (this.datos.controls.celular.value) {
        if (this.datos.controls.celular.value.length < 9) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 18);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }
      } else {
        const celular = this.datos.controls.celular.value;
        if (celular === '' || celular === null || celular === undefined) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 17);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }
      }
      if (this.datos.controls.telefono.value) {
        const telefono = this.datos.controls.telefono.value.trim();
        if (telefono.length < 7) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 20);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }
      }
      if (this.datos.controls.correo.value) {
        const EMAIL_REGEX = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
        if (!EMAIL_REGEX.test(this.datos.controls.correo.value.trim())) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 14);
          this.mensajeWarning(mensaje.vl_val_parametro);
        }
      } else {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 13);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
      if (!this.flagCodigovalidacion1) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 16);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
      return false;
    }

    return true;
  }

  async submit() {
  
    if (this.validForm() && this.validData()) {

      if (!this.checkUno) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 44);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }
      let formValue = this.datos.getRawValue();
      this.data = JSON.parse(sessionStorage.getItem('dataRegistro'));
      let secuenciaSuministro: any = this.data.secusuministro;
      let codigoOficina: any = this.data.codioficina;
      //let docAdjuntos: any = [];
      let j = 0;
      let totalSize = 0;

      this.filesMap.forEach((value: any, key: any) => {
        this.docAdjuntos.push({
          idBandeja: 0,
          tipoDocArchivo: value.item.tipo,
          nombreArchivo: this.getFileName(j, value.file, formValue),
          estadoDocumento: "DC001",////valor anterior: 'DW001'
          motivoRechazo: ' ',
          size: value.item.size,
          tipoExt: value.item.tipoExt
        });
        totalSize += value.file.size;
        j++;
      });

      formValue.telefono = formValue.telefono.replace(/\s/g, "");
      formValue.correo = formValue.correo.replace(/\s/g, "");

      if (formValue.telefono && formValue.telefono.length == 0) {
        formValue.telefono = "0";
      }

      let formData: FormData = new FormData();
      formData.append("suministro", formValue.suministro);
      formData.append("secuenciaSuministro", secuenciaSuministro);
      formData.append("codigoOficina", codigoOficina);
      formData.append("codigoParentesco", formValue.parentesco);
      formData.append("paterno", formValue.paterno ? formValue.paterno : ' ');
      formData.append("materno", formValue.materno ? formValue.materno : ' ');
      formData.append("nombres", formValue.nombres ? formValue.nombres : ' ');
      formData.append("razonsocialRRLL", formValue.razonsocialRRLL ? formValue.razonsocialRRLL: ' ');
      formData.append("tipoDocumento", formValue.tipDocumento);
      formData.append("numDocumento", formValue.numDocumento);
      formData.append("telefono", formValue.telefono ? formValue.telefono : 0);
      formData.append("celular", formValue.celular);
      formData.append("correo", formValue.correo);
      formData.append("correoSecundario", formValue.correoSecundario?formValue.correoSecundario:' ');
      formData.append("estadoSolicitud", "SO002");//valor anterior: SO001
      formData.append("motiEstadoSolic", "MS001");
      formData.append("docAdjuntos", JSON.stringify(this.docAdjuntos));
      formData.append("tipoTramite", 'WT003');
      formData.append("estadoTramite", 'TR001');//valor anterior:'AR001' 
      formData.append("validacionTelefono", this.tipoValiCell); //VT001 Simple VT002 SMS
      formData.append("tipoCliente", 'AW001');//AW001 Cliente Nuevo AW002 Existente
      formData.append("tipoPersona", this.tipoPersona);//PS001 Natural PS002 Juridica
      // P_TIP_SOL      IN SGCPROD.SGC_BANDEJA.V_TIP_SOL%TYPE,
      formData.append("declajurada", this.checkUno?'1':'0');
      formData.append("uso_dat_promocion", this.checkDos?'1':'0');

      this.filesMap.forEach((value: any) => {
        formData.append("document", value.file, value.file.name);
      });
      await this.financiamientoApiService.registrarSolicitante(formData).toPromise().then(
        (response: Response) => {
          if (response.estado === "OK") {
            if (response.resultado === 0) {
              this.globals.tipo_form_solicitante = 7;
              this.router.navigate(['/mensaje-registro']);
            }
          }
        },
        (error) => {
          console.log("Error: " + error);
        });
    }
  }

  getFileName(j: number, file: any, formValue: any) {
    let returned: string = '';
    let nroSuministro = formValue.suministro;
    let nroDocumento = formValue.numDocumento;
    let tipoExt = file.type === 'image/jpeg' ? 'jpg' : 'pdf';
    returned = nroSuministro + "_" + nroDocumento + "_" + (j + 1) + "." + tipoExt;

    return returned;
  }

  stripChanges() {
    this.datos["controls"]["numDocumento"].setValue("");
    let tipDoc = this.datos.value.tipDocumento;
    this.globals.tip_docum=this.datos.value.tipDocumento;
    if (tipDoc == "TD001") {
      //DNI
      this.validaDoc = 1; //numerico
      this.maxLength = '8';
    } else {
      if (tipDoc == "TD002") {
        //RUC
        this.validaDoc = 1; //numerico
        this.maxLength = '11';
      } else {
        if (tipDoc == "TD003") {
          //CARNET DE EXTRANJERIA
          this.validaDoc = 2; //alfa-numerico
          this.maxLength = '12';
        } else {
          if (tipDoc == "TD005") {
            //PASAPORTE
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '12';
          } else {
            //LOS DEMAS TIPOS
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '15';
          }
        }
      }
    }
  //  this.flagMensaje = false;
  this.buscarDocs();
  }

  stripValidaDocumentoLength(){

    let tipDoc = this.datos.value.tipDocumento;
    if (tipDoc == "TD001") {
      //DNI
      let numDocuValido = false;
      let numDocu = this.datos.value.numDocumento;
      let CELULAR_REGEX = /^[0-9]{8}$/;
      numDocu = String(numDocu);

      if (numDocu.match(CELULAR_REGEX)) {
        numDocuValido = true;
      }
      if (!numDocuValido) {
        this.blockUI.stop();
        this.toastr.warning('El numero de documento DNI debe tener 8 digitos', 'Atención', {closeButton: true});
        return;
      }

    } else {
      if (tipDoc == "TD002") {
        //RUC
        let numDocuValido = false;
        let numDocu = this.datos.value.numDocumento;
        let CELULAR_REGEX = /^[0-9]{11}$/;
        numDocu = String(numDocu);

        if (numDocu.match(CELULAR_REGEX)) {
          numDocuValido = true;
        }
        if (!numDocuValido) {
          this.blockUI.stop();
          this.toastr.warning('El numero de documento RUC debe tener 11 digitos', 'Atención', {closeButton: true});
          return;
        }
      }
    }

  }


  stripValidaDocumento(event: KeyboardEvent) {

    const patternNumber = /[0-9]/;
    const patternAlfaNumeric = /[a-zA-Z0-9]/;

    const inputChar = String.fromCharCode((event).charCode);
    if (this.validaDoc == 1) {
      if (!patternNumber.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    } else {
      if (this.validaDoc == 2) {
        if (!patternAlfaNumeric.test(inputChar)) {
          // invalid character, prevent input
          event.preventDefault();
        }
      }
    }
  }

  //Focos para los codigos 1-4
  processKeyUp(e, el) {
    el.focus();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

}
